import { UserRole } from '@/types/user';

export const RULE_BASED_TEMPLATES_FLAG = 'rule_based_personalized_templates';

export interface ReportInterpretationTemplate {
  id: string;
  name: string;
  source: 'personal' | 'clinic';
}

/** Roles that can call /organizations/:clinicId/my/interpretation-rules. */
const MY_TEMPLATE_ROLES = new Set<string>([
  UserRole.InternalClinical,
  UserRole.InternalNonClinical,
  UserRole.ExternalAdmin,
  UserRole.ExternalProvider,
  UserRole.ExternalPractitioner,
  UserRole.ExternalNonPractitioner,
  UserRole.ExternalPractitionerAdmin,
  UserRole.ExternalNonPractitionerAdmin
]);

export function usesMyTemplateRoutes(role?: string | null): boolean {
  return Boolean(role && MY_TEMPLATE_ROLES.has(role));
}

/**
 * Prefill only when the report has no text yet and the picker chose a template.
 * Existing clinician notes and physician comments stay as they are.
 */
export function shouldPrefillTemplate(
  existingText: string | null | undefined,
  preselectedTemplateId?: string | null
): boolean {
  if (!preselectedTemplateId) return false;
  return !(existingText ?? '').trim();
}

/** Keep the server order: personal default, then other personal templates, then clinic templates. */
export function interpretationTemplateOptions(
  templates: ReportInterpretationTemplate[]
): Array<{ label: string; value: string }> {
  return templates.map((template) => ({
    label: template.source === 'personal' ? `${template.name} (Mine)` : template.name,
    value: template.id
  }));
}

export function interpretationRulePatchBody(rule: {
  isCatchAll: boolean;
  deviceTypes: string[];
  alertTypes: string[];
  appointmentTypes: string[];
  templates: Array<{ name: string; body: string; isDefault: boolean }>;
}): Record<string, unknown> {
  if (rule.isCatchAll) return { templates: rule.templates };
  return {
    deviceTypes: rule.deviceTypes,
    alertTypes: rule.alertTypes,
    appointmentTypes: rule.appointmentTypes,
    templates: rule.templates
  };
}
